export default __webpack_public_path__ + "static/media/forwardEnd.f94a53d9.svg";